import { render, staticRenderFns } from "./SectionListMovie.vue?vue&type=template&id=737649f1&"
import script from "./SectionListMovie.vue?vue&type=script&lang=js&"
export * from "./SectionListMovie.vue?vue&type=script&lang=js&"
import style0 from "./SectionListMovie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports